<template>
    <div class="bg-white rounded shadow min-h-screen">
        <Row type="none" class="bg-white rounded shadow">

            <div class="grid grid-cols-12 py-4 container">
                <div class="col-span-12 md:col-span-3">
                    <button
                        class="h-11 w-44 rounded bg-main hover:bg-hoverMain focus:ring-0 z-40 text-white font-bold border-0"
                        @click="$i18nHelper.toUrl('companyCount/add')"
                    >
                        {{ $t('finance.newCount') }}
                    </button>
                </div>
                <div class="col-span-12 md:col-span-9 text-gray-500 font-bold mt-3 mt-md-0 md:text-xl flex items-center justify-center">
                    {{$t('totalBalance')}}: {{ showCurrencyById(getCompanyCountTotalAmount.currency.id, getCompanyCountTotalAmount.amount) }}
                </div>
            </div>
        </Row>

        <Row type="none" class="mt-4">
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 sm:col-span-6 xl:col-span-4 relative border border-gray-300 rounded bg-white shadow" v-for="companyCount of getCompanyCounts" :key="companyCount.id">
                    <div
                        @click="$i18nHelper.toUrl('companyCount/' + companyCount.id)"
                        class="group absolute left-2 top-2"
                    >
                        <img src="/images/edit.png" alt="" class="h-5 cursor-pointer">
                        <span class="group-hover:opacity-100 bg-gray-700 -top-5 left-2 px-1 text-sm text-gray-100 rounded absolute opacity-0 z-30">{{ $t('edit') }}</span>
                    </div>
                    <div v-if="!companyCount.isMain" @click="deleteIncome(companyCount.id)" class="group absolute right-2 top-2">
                        <span class="group-hover:opacity-100 bg-gray-700 -top-5 left-2 px-1 text-sm text-gray-100 rounded absolute opacity-0 z-30">{{ $t('delete') }}</span>
                        <img src="/images/Union.png" alt="" class="h-6 cursor-pointer">
                    </div>
                    <div class="flex justify-center pt-4">
                        <div class="bg-mediumGray h-20 w-20 rounded-full flex justify-center items-center">
                            <img src="/images/bank.png" alt="" class="h-12">
                        </div>
                    </div>

                    <div class="flex justify-center items-center text-main font-bold">
                        <div>
                            {{companyCount.isMain ? $t('main') : companyCount.name}}
                        </div>
                    </div>

                    <hr>

                    <div class="pb-2">
                        <div class="font-bold text-gray-500 pl-3">
                            {{ $t('finance.balance') }}:
                            <span v-if="companyCount.balanceCurrency === null">0.0000</span>
                            <span v-else>{{ showCurrencyById(companyCount.balanceCurrency.id, companyCount.balance) }}</span>
                        </div>
                        <div class="font-bold text-gray-500 pl-3">{{ $t('createdAt') }}: {{ dateFormat(companyCount.createdAt) }}</div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col mt-3 ml-4">
                    <Pagination
                        :search="search"
                        base-url="companyCounts"
                        :total-items="getCompanyCountsTotalCount"
                        method-name="fetchCompanyCounts"
                    />
                </div>
            </div>
        </Row>
    </div>
</template>

<script>
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import {mapActions, mapGetters} from "vuex";
import Pagination from "@/components/html/Pagination";
import companyCount from "@/store/modules/companyCount";
import currencyFormat from "@/mixin/currencyFormatMixin";
import Row from "@/components/html/Row.vue";

export default {
    name: "List",
    components: {
        Row,
        Pagination,
    },
    mixins: [currencyFormat, dateFormattingMixin, currencyRateMixin],
    data() {
        return {
            page: 1,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'finance.title', url: 'companyCount'},
                {name: 'finance.counts', },
            ],
            search: {
                page: 1
            },
            isShowMore: false
        }
    },
    computed: {
        companyCount() {
            return companyCount
        },
        ...mapGetters([
            'getCompanyCounts',
            'getCompanyCountsTotalCount',
            'getUserCompanyName',
            'getCompanyCountTotalAmount'
        ]),
    },
    methods: {
        ...mapActions([
            'fetchCompanyCounts',
            'fetchUser',
            'fetchCompanyCountsTotalAmount',
            'deleteCompanyCount',
            'setBreadcrumbItems'
        ]),
        deleteIncome(id) {
            this.$root.showOverlay = true
            this.deleteCompanyCount(id)
                .then(() => {
                    this.$i18nHelper.flash(this.$t('finance.deleteCountInfo'), 'success')
                    this.fetchCompanyCounts(this.search)
                })
                .catch(() => {
                    this.$i18nHelper.flash(this.$t('unknownError'), 'error')
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        backgroundColor(isIncome) {
            return isIncome ? '#64C96E' : '#F2ACAC'
        },
        searchFilters() {
            this.$root.showOverlay = true
            this.searchIncomeAndOutcome(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        resetProductPurchaseSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchFilters()
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchCompanyCounts(this.search)
        this.fetchCompanyCountsTotalAmount()
            .then(() => {
            })
        this.fetchUser()
    },
}
</script>

<style scoped>
.btn-secondary {
    background-color: #ffffff !important;
    border: none;
    padding: 0;
}
</style>